import { ResultPagDTO } from "@/interfaces/base-dto";
import { DisparoWhatsappParmDTO, PendenciaPrescricaoFiltroDTO, TentativaContatoParmDTO } from "@/interfaces/pending-prescriptions";
import { ENDPOINTS } from "@/settings/api-settings";
import { Observable, from } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";


export function findPendingPrescriptionsByFilters(filters: PendenciaPrescricaoFiltroDTO): Observable<ResultPagDTO<any>> {
  return from(apiClient.get(`${ENDPOINTS.PENDING_PRESCRIPTIONS}`, filters)).pipe(map((r: any) => r.data));
}

export function listPendingPrescriptionStatusFilter(): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.PENDING_PRESCRIPTIONS_STATUSES_FILTER}`)).pipe(map((r: any) => r.data));
}

export function listPendingPrescriptionStatusEdit(): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.PENDING_PRESCRIPTIONS_STATUSES_EDIT}`)).pipe(map((r: any) => r.data));
}

export function listPendingPrescriptionHistory(id: Number): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.PENDING_PRESCRIPTIONS}/${id}/historico`)).pipe(map((r: any) => r.data));
}

export function findPendingPrescriptionsById(id: Number): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.PENDING_PRESCRIPTIONS}/${id}`)).pipe(map((r: any) => r.data));
}

export function savePendingPrescriptionContact(parm: TentativaContatoParmDTO): Observable<any> {
  return from(apiClient.put(`${ENDPOINTS.PENDING_PRESCRIPTIONS}`, parm)).pipe(map((r: any) => r.data));
}

export function listPendingPrescriptionWhatsappVariables(id: Number): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.PENDING_PRESCRIPTIONS_WHATSAPP_VARIABLES}`.replace('{id}', id.toString()))).pipe(map((r: any) => r.data));
}

export function sendPendingPrescriptionWhatsappMessage(parm: DisparoWhatsappParmDTO): Observable<any> {
  return from(apiClient.post(`${ENDPOINTS.PENDING_PRESCRIPTIONS_WHATSAPP}`, parm)).pipe(map((r: any) => r.data));
}

